module.exports = "/_next/static/images/icon8-6d2372c821b0d7e3b7ac16a4722e5cc4.png";